;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Collection = APP.module('Collection'),
		  Model      = APP.module('Model'),
		  FetchCache = APP.module('FetchCache');

	Collection.Rounds = Collection.FetchCache.extend({
		model: Model.Round,
		url: 'rounds.json',
		checksumEmitter: new APP.ChecksumEmitter(),
		toObjectByParam: function(param) {
			return _.indexBy(this.toJSON(), param || 'id');
		},
		setSquadNamesForAll: function(id, squads) {
			const squad_names = squads.toObjectByParam();
			this.each(round => round.set({ squad_names }));
			return this;
		},
		setSquadNames: function(id, squads) {
			var
				round       = this.get(id),
				squad_names = {}
			;

			squads.each(function(squad) {
				squad = squad.toJSON();
				squad_names[squad.id] = squad;
			});

			round.set({
				squad_names: squad_names
			});

			return this;
		},
		setVenuesNames: function(id, venues) {
			var
				round       = this.get(id),
				venue_names = {}
			;

			venues.each(function(venue) {
				venue = venue.toJSON();
				venue_names[venue.id] = venue;
			});

			round.set({
				venue_names: venue_names
			});

			return this;
		},
		setTippingTrends: function(id, trends) {
			var
				round       = this.get(id),
				trend_obj = {}
				;

			_.each(trends, function(trend) {
				trend_obj[trend.match_id] = trend;
			});

			round.set({
				trends: trend_obj
			});

			return this;
		},

		getActiveRound: function() {
			// it is expected that this method returns undefined if no active round is found
			return this.find(function(round) {
				return round.get('status') === 'active';
			});
		},

		getActualRound: function() {
			//set CONFIG.END_ROUND to 31
			const rounds = this.filter(round => !CONFIG.END_ROUND || 31 >= round.id);
			var actual_round = _.find(rounds, function(round) {
				return Boolean(~['scheduled', 'active'].indexOf(round.get('status')));
			});
			return actual_round || _.last(rounds);
		},

		getScheduledRound() {
			var scheduled_round = this.find(function(round) {
				return round.get('status') === 'scheduled';
			});

			return scheduled_round || this.last();
		},

		getCompletedRounds() {
			const completed_rounds = this.filter(function(round) {
				return round.get('status') === 'complete';
			});

			return completed_rounds;
		},

		getLastCompletedRound() {
			return _.last(this.getCompletedRounds()) || this.first();
		},

		getLastRoundCompleteID(){
			let round =  this.getLastCompletedRound();

			return round ? round.get('id') : 0;
		},

		getNotCompletedRounds: function(){
			return this.filter(function(round) {
				return Boolean(~['scheduled', 'active'].indexOf(round.get('status')));
			});
		},

		getFirstScheduledRoundId: function(){
			var scheduled_round = this.find(function (round) {
					return round.get('status') == 'scheduled';
				}),
				round           = scheduled_round ? scheduled_round.get('id') - 1 : this.last().get('id');

			return round;
		},

		getNextScheduledRoundId: function(){
			var scheduled_round = this.find(function(round) {
					return round.get('status') === 'scheduled';
				});

			return _.isNumber(scheduled_round.id) ? scheduled_round.id : this.last().get('id');
		},

		getActiveOrNextScheduledRound() {
			// it is expected that this method returns undefined if no rounds are found
			return this.getActiveRound() || this.getNextScheduledRound();
		},

		getNextScheduledRound() {
			// it is expected that this method returns undefined if no next scheduled round is found
			return this.find(function(round) {
				return round.get('status') === 'scheduled';
			});
		},

		getLastPlayedRound: function(){
			let
				round      = this.getActualRound(),
				round_id   = round.get('id'),
				prev_round = this.get(round_id - 1)
			;

			if(round.get('status') === 'scheduled' && prev_round){
				round = prev_round;
			}

			return round;
		},

		getActiveOrLastCompletedRound: function(){
			return this.getActiveRound() || this.getLastCompletedRound() || 0;
		},

		getActiveOrLastCompletedRoundId: function(){
			let active_round_id;
			let last_completed_round_id;

			const active_round =  this.getActiveRound();

			if (active_round) {
				active_round_id = active_round.get('id');
			}
			else {
				const last_completed_round = this.getLastCompletedRound();

				if (last_completed_round) {
					last_completed_round_id = last_completed_round.get('id');
				}
			}

			return active_round_id || last_completed_round_id;
		},

		getLastGameRound: function(){
			var
				round      = this.getActualRound(),
				round_id   = round.get('id'),
				prev_round = this.get(round_id - 1)
			;

			if(round.get('status') === 'scheduled' && prev_round){
				round = prev_round;
			}

			return round;
		},

		getLeagueStartOrLastGame: function(id) {
			var round = this.getLastGameRound();
			if (round.get('id') < id) {
				round = this.get(id);
			}
			return round;
		},

		getLeagueStartOrActualRound: function(id) {
			var round = this.getActualRound();
			if (round.get('id') < id) {
				round = this.get(id);
			}
			return round;
		},

		getActualRoundId: function() {
			var actual_round = this.getActualRound();
			return actual_round && actual_round.get('id');
		},

		getScheduledRoundId: function() {
			return this.getScheduledRound().get('id');
		},

		getRoundsOptions: function() {
			var options = [];

			this.each(function(round) {
				if (round.get('status') == 'scheduled') {
					const label = round.id === 0 ? 'Opening Round' : 'Round ' + round.get('id');
					options.push({
						val:   round.get('id'),
						label: label
					});
				}
			});

			return options;
		},

		getPlayedRoundsOptions: function() {
			var options = [];

			this.each(function(round) {
				const is_first_game_played = round.get('status') === 'active' && round.get('matches')[0].status === 'complete';
				if (round.get('status') === 'complete' || is_first_game_played) {
					const label = round.id === 0 ? 'Opening Round' : 'Round ' + round.get('id');

					options.push({
						val:      round.get('id'),
						label:    label,
						selected: round.get('selected') || false
					});
				}
			});

			return options;
		},

		getCompleteAndPlayedRoundsOptions: function() {
			var options = [];

			this.each(function(round) {
				if (Boolean(~['complete', 'active'].indexOf(round.get('status')))) {
					options.push({
						val:      round.get('id'),
						label:    'RD ' + round.get('id'),
						selected: round.get('selected') || false
					});
				}
			});

			return options;
		},

		getCompleteAndActiveRounds() {
			let rounds = this.filter(round => Boolean( ~['complete', 'active'].indexOf( round.get('status') ) ) );
			if (CONFIG.END_ROUND) {
				rounds = rounds.filter(round => round.id <= CONFIG.END_ROUND);
			}
			return rounds || this.first();
		},

		changeRoundStatus: function(round_id){

			var options = [];

			this.each(function(round) {

				if (round.get('status') === 'complete') {
					const label = round.id === 0 ? 'Opening Round' : 'Round ' + round.get('id');

					options.push({
						val:      round.get('id'),
						label:    label,
						selected: (round.get('id') == round_id) || false
					});
				}
			});

			return options;

		},

		getRoundsOptionsToId: function(round_id) {
			var options = [];

			this.each(function(round) {
				if (round.get('id') <= round_id) {
					const label = round.id === 0 ? 'Opening Round' : 'Round ' + round.get('id');

					options.push({
						val:   round.get('id'),
						label: label
					});
				}
			});

			return options;
		},

		getByeRoundIds: function() {
			var ids = [];

			this.each(function(round) {
				if (round.get('is_bye')) {
					ids.push(round.get('id'));
				}
			});

			return ids;
		},
		getRoundBefore: function(round_id){
			var current_round = this.get(round_id);

			return this.indexOf(current_round) ? this.at(this.indexOf(current_round) - 1) : null;
		},
		getRoundAfter: function(round_id){

			var current_round = this.get(round_id);

			return this.at(this.indexOf(current_round) + 1);

		},
		isSquadPlayingNow: function(squad_id){

			var activeRound = this.getActiveRound();

			if(activeRound){
				return activeRound.isSquadPlayingNow(squad_id);
			}

			return false;

		},
		getMatchById: function(match_id){
			return this.filter(function(round){
				return round.get('matches').filter(function(match){
					if(match.id === match_id){
						return match
					}
				}).shift();
			}).shift();
		},
        getRoundByMatchId: function(match_id){
            return this.filter((round) => {
            	const matches = round.get('matches');
            	const match =  _.some(matches, match => match.id === match_id);
            	return Boolean(match);
            }).shift();
        },
		getActualMatchById: function(match_id){
			var search_match = null;
			this.filter(function(round){
				return round.get('matches').filter(function(match){
					if(match.id === match_id){
						search_match = match;
					}
				}).shift();
			}).shift();

			return search_match;
		},
		getSheduledRoundsMatches: function(){
			var rounds = this.getNotCompletedRounds(),
				matches = [];

			_.each(rounds, function(round){

				var scheduled_matches = _.filter(round.get('matches'), function(match){
					return match.status === 'scheduled';
				})

				_.each(scheduled_matches, function(match){
					matches.push(match);
				});

			});

			return matches;
		},

		getNonScheduledOptionsFromId: function(round_id) {
			var options = [];

			this.each(function(round) {
				const { id, status } = round.attributes;
				if (CONFIG.END_ROUND && CONFIG.END_ROUND < id) {
					return;
				}
				if (id >= round_id && ['complete', 'active'].includes(status)) {
					options.push({
						val:   round.get('id'),
						label: 'Game Week ' + round.get('id'),
						selected: round.get('selected') || false
					});
				}
			});

			return options;
		},

		getLabel: function(id, date){
			var str_date = '',
				str_label = this.getLabelPrefix();

			if(date){
				var
					days      = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					months    = [
						'January', 'February', 'March',
						'April', 'May', 'June',
						'July', 'August', 'September',
						'October', 'November', 'December'
					],

					full_date = new Date(date),
					day       = days[full_date.getDay()],
					cur_date  = full_date.getDate(),
					month     = months[full_date.getMonth()];

				str_date = ' - ' + day + ' ' + cur_date + ' ' + month

			}

			return str_label + id + str_date;
		},

		getLabelPrefix: function () {
			return 'Round ';
		},

		getLastSpringRoundID() {
			const rounds = this.toJSON();
			const spring_rounds = _.filter(rounds, round => round.type === 'spring') || [_.first(rounds)];
			const last_round = _.last(spring_rounds) || {};

			return last_round ? last_round.id : 0
		}
	});

}(window, APP, Backbone, Marionette, $, _));